export default "__VITE_ASSET__XrbGvOVf__"